import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-not-logged-layout',
  templateUrl: './not-logged-layout.component.html',
  styleUrls: ['./not-logged-layout.component.scss']
})
export class NotLoggedLayoutComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
